import { PopupHuchaCardContainer } from '../../../ui/popup-hucha-card-container';
import React from 'react';
import { PopupRenovadoresBonusCardC2 } from './popup-renovadores-bonus-card-c2';
import { PopupRenovadoresBonusCardC3 } from './popup-renovadores-bonus-card-c3';

export const PopupRenovadoresBonusCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PopupHuchaCardContainer>
			<PopupRenovadoresBonusCardC2 dineroHucha={dineroHucha} />
			<PopupRenovadoresBonusCardC3 />
		</PopupHuchaCardContainer>
	);
};
